import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import pluginHero from "../../../static/images/distant_bass_suite/plugin-hero.webp"
import pluginHeroSmall from "../../../static/images/distant_bass_suite/plugin-hero-800.webp"
import heroBackground from "../../../static/images/distant_bass_suite/hero-background.webp"

const Image = () => {
  return <img
    fetchpriority="high"
    loading="eager"
    decoding="async"
    alt="BassSuite - Distant plugin interface showing the Skinscraper amplifier"
    src={pluginHero}
    srcSet={`${pluginHeroSmall} 800w, ${pluginHero} 1600w`}
    sizes="(min-width: 432px) 400px, calc(100vw - 32px)"
    width={1600}
    height={1079}
    style={{ width: "100%", height: "auto", maxWidth: "400px" }}
  />
}

const BassDistantFrontpageTile = () => {

  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < window.innerHeight
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();

    window.addEventListener("resize", () => setResponsiveness());
  }, []);

  return (
    <Box
      sx={{
        backgroundSize: "cover",
        position: "relative",
        isolation: "isolate",
        m: 0,
        flex: 100,
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        display: { xs: "block", md: "flex" },
        flexDirection: "column",
        flexGrow: 10,
        height: "100%",
        overflow: "hidden"
      }}
    >
      <Box sx={{
        position: "absolute",
        top: 0,
        bottom: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
        zIndex: -2,
        backgroundImage: `url(${heroBackground})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
      }}>
        <div
          style={{
            zIndex: 0,
            position: "absolute",
            pointerEvents: "none",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.0) 0%, #000 95%)",
          }}
        ></div>
      </Box>
      <Box sx={{ p: 2, position: "relative", zIndex: 1 }}>
        <Image />
        <Typography
          variant="h3"
          fontSize={30}
          sx={{ fontSize: 30, }}
        >
          BassSuite - Distant
        </Typography>
        <Typography
          style={{
            fontSize: state.mobileView ? "15px" : "20px",
          }}
        >
          <i>Extreme. Unapologetic. BASS.</i>
        </Typography>
        <Button
          component="a"
          href="/product/distant-bass-suite"
          aria-label="Learn more about BassSuite - Distant"
          sx={{
            mt: 4,
            background: "white",
            color: "black", width: { xs: "75%", md: "150px" },
            textDecoration: "none",
          }}
          variant="outlined"
        >
          Learn More<span className="sr-only"> about BassSuite - Distant</span>
        </Button>
      </Box>
    </Box>
  );
}

export default BassDistantFrontpageTile;
